import { autocompleteApiService } from '@autocomplete/service';
import { authQuery } from '../config/query.config';

export const autocompleteApi = autocompleteApiService(authQuery);
export const { useGetUserSuggestionsQuery } = autocompleteApi;
